// Mutations
export const SET_TEAMS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.teams.data = payload
    state.teams.lastUpdate = new Date()
  }
}
export const ADD_TEAMS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.teams.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.teams.data.push(data)
      }
    })
  }
}
export const SET_TEAMS_LOADING = (state, payload) => {
  state.teams.loading = payload
}

export const SET_ROAS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.roas.data = payload
    state.roas.lastUpdate = new Date()
  }
}
export const ADD_ROAS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.roas.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.roas.data.push(data)
      }
    })
  }
}
export const SET_ROAS_LOADING = (state, payload) => {
  state.roas.loading = payload
}
export const SET_FAMILY_GROUP = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.familyGroup.data = payload
    state.familyGroup.lastUpdate = new Date()
  }
}
export const ADD_FAMILY_GROUP = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.familyGroup.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.familyGroup.data.push(data)
      }
    })
  }
}
export const SET_FAMILY_GROUP_LOADING = (state, payload) => {
  state.familyGroup.loading = payload
}

export const SET_OFFICE_PARAMETRIZATION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.officeParametrization.data = payload
    state.officeParametrization.lastUpdate = new Date()
  }
}
export const ADD_OFFICE_PARAMETRIZATION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.officeParametrization.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.officeParametrization.data.push(data)
      }
    })
  }
}
export const SET_OFFICE_PARAMETRIZATION_LOADING = (state, payload) => {
  state.officeParametrization.loading = payload
}

export const SET_BENCHMARKS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.benchmarks.data = payload
    state.benchmarks.lastUpdate = new Date()
  }
}
export const ADD_BENCHMARKS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.benchmarks.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.benchmarks.data.push(data)
      }
    })
  }
}
export const SET_BENCHMARKS_LOADING = (state, payload) => {
  state.benchmarks.loading = payload
}

export const SET_RUBRICS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.rubrics.data = payload
    state.rubrics.lastUpdate = new Date()
  }
}
export const ADD_RUBRICS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.rubrics.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.rubrics.data.push(data)
      }
    })
  }
}
export const SET_RUBRICS_LOADING = (state, payload) => {
  state.rubrics.loading = payload
}
export const SET_DEPARTMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.departments.data = payload
    state.departments.lastUpdate = new Date()
  }
}
export const ADD_DEPARTMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.departments.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.departments.data.push(data)
      }
    })
  }
}
export const SET_DEPARTMENTS_LOADING = (state, payload) => {
  state.departments.loading = payload
}

export const SET_PERMISSIONS_ASSESSOR = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.permissionsAssessor.data = payload
    state.permissionsAssessor.lastUpdate = new Date()
  }
}
export const ADD_PERMISSIONS_ASSESSOR = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.permissionsAssessor.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.permissionsAssessor.data.push(data)
      }
    })
  }
}
export const SET_PERMISSIONS_ASSESSOR_LOADING = (state, payload) => {
  state.permissionsAssessor.loading = payload
}

export const SET_ROUTES_SETTINGS = (state, payload) => {
  const data = [...state.routesSettings[payload.origin].pathRoutes]
  const findIndex = data.findIndex((r) => r.name === payload.name)
  if (findIndex < 0) {
    data.push(payload)
  }

  state.routesSettings[payload.origin].pathRoutes = data
}

export const REMOVE_ROUTES_SETTINGS = (state, payload) => {
  const data = [
    ...((state.routesSettings[payload.origin] || {}).pathRoutes || []),
  ]

  const findIndex = data.findIndex((r) => r.name === payload.name)

  data.splice(findIndex, 1)

  state.routesSettings[payload.origin].pathRoutes = data
}

export const CLEAR_ROUTES_SETTINGS = (state, payload) => {
  state.routesSettings[payload.origin].pathRoutes = []
}
export const SET_REPOSITORY_FILES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.repositoryFiles.data = payload
    state.repositoryFiles.lastUpdate = new Date()
  }
}
export const ADD_REPOSITORY_FILES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.repositoryFiles.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.repositoryFiles.data.push(data)
      }
    })
  }
}
export const SET_REPOSITORY_FILES_LOADING = (state, payload) => {
  state.repositoryFiles.loading = payload
}

export const SET_ASSET_ALLOCATION_TYPES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.assetAllocationTypes.data = payload
    state.assetAllocationTypes.lastUpdate = new Date()
  }
}
export const ADD_ASSET_ALLOCATION_TYPES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let items = window.structuredClone(payload)
    if (!Array.isArray(items)) {
      items = [items]
    }
    items.forEach(function (data) {
      const old = state.assetAllocationTypes.data.find(function (item) {
        return item.id === data.id
      })
      if (old) {
        Object.keys(data).forEach(function (key) {
          old[key] = data[key]
        })
      } else {
        state.assetAllocationTypes.data.push(data)
      }
    })
  }
}
export const SET_ASSET_ALLOCATION_TYPES_LOADING = (state, payload) => {
  state.assetAllocationTypes.loading = payload
}

export const SET_DRE_TEMP_FILTERS = (state, payload) => {
  state.dreTempFilters.data = {
    ...state.dreTempFilters.data,
    ...payload,
  }
}

export const SET_SUPER_RANKING_CLUSTERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.superRankingClusters.data = payload
    state.superRankingClusters.lastUpdate = new Date()
  }
}
export const SET_SUPER_RANKING_CLUSTERS_LOADING = (state, payload) => {
  state.superRankingClusters.loading = payload
}

export const SET_SUPER_RANKING_CYCLES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.superRankingCycles.data = payload
    state.superRankingCycles.lastUpdate = new Date()
  }
}
export const SET_SUPER_RANKING_CYCLES_LOADING = (state, payload) => {
  state.superRankingCycles.loading = payload
}

export const SET_SUPER_RANKING_INDICATORS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.superRankingIndicators.data = payload
    state.superRankingIndicators.lastUpdate = new Date()
  }
}
export const SET_SUPER_RANKING_INDICATORS_LOADING = (state, payload) => {
  state.superRankingIndicators.loading = payload
}

export const SET_SUPER_RANKING_FUNCTIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.superRankingFunctions.data = payload
    state.superRankingFunctions.lastUpdate = new Date()
  }
}
export const SET_SUPER_RANKING_FUNCTIONS_LOADING = (state, payload) => {
  state.superRankingFunctions.loading = payload
}

export const SET_OPEN_FINANCE_CONEXOES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.openFinanceConexoes = {
      index: Array.isArray(payload.index) ? payload.index : [],
      data: Array.isArray(payload.data) ? payload.data : [],
    }
  } else {
    state.openFinanceConexoes = { index: [], data: [] }
  }
}
